<template>
  <div id="app">
    <nav
      class="navbar is-fixed-top"
      role="navigation"
      aria-label="main navigation"
    >
      <div class="navbar-brand">
        <router-link exact class="navbar-item" to="/">
          <logo />
          <h1>
            Windu
          </h1>
        </router-link>

        <a
          role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarElement"
        >
          <span aria-hidden="true" />
          <span aria-hidden="true" />
          <span aria-hidden="true" />
        </a>
      </div>

      <div id="navbarElement" class="navbar-menu">
        <div class="navbar-start">
          <router-link
            class="navbar-item"
            :to="{ name: 'Login' }"
            v-if="!verified"
          >
            Connexion
          </router-link>
          <template v-else>
            <router-link class="navbar-item" :to="{ name: 'Portal' }">
              Portail
            </router-link>
            <router-link class="navbar-item" :to="{ name: 'Users' }">
              Utilisateurs
            </router-link>
            <logout class="navbar-item" />
          </template>
        </div>

        <div class="navbar-end">
          <div class="navbar-item">
            <div class="buttons">
              <a
                class="button is-light"
                href="mailto:iteam@green-conseil.com?subject=Demande d'accès à Windu&body=Prénom :%0ANom :%0ATéléphone :%0AEmail :"
              >
                <strong>Demandes d'accès</strong>
              </a>
              <a
                class="button is-success is-outlined"
                href="https://green-conseil.com/"
                target="_blank"
              >
                Site web
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <transition :name="transitionName" :mode="transitionMode">
      <router-view />
    </transition>
  </div>
</template>

<script>
import logo from "@/components/brands/Logo";
import Logout from "@/components/navigations/Logout";
import { mapGetters } from "vuex";

export default {
  beforeMount() {
    document.querySelector("body").classList.add("has-navbar-fixed-top");
  },
  beforeDestroy() {
    document.querySelector("body").classList.remove("has-navbar-fixed-top");
  },
  data() {
    return {
      transitionName: "slide-left",
      transitionMode: "out-in"
    };
  },
  components: { logo, Logout },
  computed: {
    ...mapGetters("auth", ["verified", "status"])
  },
  watch: {
    $route(to, from) {
      if (to.name === "Portal" && from.name === "Login") {
        this.transitionName = "fade";
        return;
      }
      if (from.name === "Portal" && to.name === "Login") {
        this.transitionName = "fade";
        return;
      }
      this.transitionName =
        this.transitionName === "slide-left" ? "slide-right" : "slide-left";
    }
  }
};
</script>

<style scoped lang="scss">
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
